import { render, staticRenderFns } from "./AgencyPasswordNew.vue?vue&type=template&id=55a66e78&"
import script from "./AgencyPasswordNew.vue?vue&type=script&lang=js&"
export * from "./AgencyPasswordNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports